export default "__VITE_ASSET__DMvxWhe$__"